<template>
   
    <v-card>
    <v-overlay :value="overlayStart" class="d-flex justify-center">
        <v-progress-linear indeterminate color="cyan" ></v-progress-linear>
        <v-card class="pa-2 ma-2" color="blue" >
          {{ titleCard }}
        </v-card>
    </v-overlay>
     <v-card-title>
       <v-icon x-large>mdi-alarm-multiple</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="blackoutWDays"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
  
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px"> <!-- Edit -->

          <!-- Loading Overlay -->
          <v-overlay :value="overlay" class="d-flex justify-center">
              <v-progress-linear indeterminate color="cyan" ></v-progress-linear>
              <v-card class="pa-2 ma-2" color="blue" >
                {{ titleCard }}
              </v-card>
          </v-overlay>

          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="6"> <!-- Blackout Id  -->
                      <v-text-field :disabled="true" type="number" v-model="editedItem.BlackOut_id"
                        label="BlackOut ID"  :counter="10" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Descripcion -->
                      <v-text-field v-model="editedItem.BlackOut_Desc" :rules="DescRules" label="Descripción"
                        :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Start Time -->
                      <v-text-field
                        v-model="editedItem.BlackOutStart_tm"
                        :rules="InicioRules"
                        type="time"
                        step="2"
                        label="Hora de Inicio"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- End Time -->
                      <v-text-field
                        v-model="editedItem.BlackOutEnd_tm"
                        :rules="FinRules"
                        type="time"
                        step="2"
                        label="Hora de Fin"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Start Dt -->
                      <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.EffectiveDate"
                              label="Fecha Efectiva"
                              prepend-icon="mdi-calendar-today"
                              :rules="InicioRules"
                              readonly
                              required
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.EffectiveDate" @input="menu = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- End Dt -->
                      <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.ExpirationDate"
                              label="Fecha Expiración"
                              prepend-icon="mdi-calendar-today"
                              :rules="FinRules"
                              required
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.ExpirationDate" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Api Role Id -->
                      <v-select
                        v-model="editedItem.ApiRole_id"
                        :items="roles"
                        :rules="idRolRules"
                        label="Rol ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Last User Id -->
                      <v-text-field :disabled="true"  v-model="editedItem.LastUser_id"
                        label="Usuario Modificación"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12"> <!-- Dias de la semana -->
                      <span>{{ 'Días de la semana: '}}</span>
                      <v-row justify="space-around">
                      
                      <v-checkbox v-model="selectedDays" label="Lunes" value="1"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Martes" value="2"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Miercoles" value="3"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Jueves" value="4"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Viernes" value="5"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Sabado" value="6"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Domingo" value="7"></v-checkbox>
                    </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_pass" max-width="900px">
          <!-- Loading Overlay -->
          <v-overlay :value="overlayStart" class="d-flex justify-center">
              <v-progress-linear indeterminate color="cyan" ></v-progress-linear>
              <v-card class="pa-2 ma-2" color="blue" >
                {{ titleCard }}
              </v-card>
          </v-overlay>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px"> <!-- Nuevo Blackout -->
          <!-- Loading Overlay -->
          <v-overlay :value="overlay" class="d-flex justify-center">
              <v-progress-linear indeterminate color="cyan" ></v-progress-linear>
              <v-card class="pa-2 ma-2" color="blue" >
                {{ titleCard }}
              </v-card>
          </v-overlay>
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO BLACKOUT</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="12"> <!-- Descripcion -->
                      <v-text-field v-model="editedItem.BlackOut_Desc" :rules="DescRules" label="Descripción"
                        :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Start Time -->
                      <v-text-field
                        v-model="editedItem.BlackOutStart_tm"
                        :rules="InicioRules"
                        type="time"
                        step="2"
                        label="Hora de Inicio"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- End Time -->
                      <v-text-field
                        v-model="editedItem.BlackOutEnd_tm"
                        :rules="FinRules"
                        type="time"
                        step="2"
                        label="Hora de Fin"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Start Dt -->
                      <v-menu
                          v-model="menu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.EffectiveDate"
                              label="Fecha Efectiva"
                              prepend-icon="mdi-calendar-today"
                              :rules="InicioRules"
                              required
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.EffectiveDate" @input="menu3 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- End Dt -->
                      <v-menu
                          v-model="menu4"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.ExpirationDate"
                              label="Fecha Expiración"
                              prepend-icon="mdi-calendar-today"
                              :rules="FinRules"
                              required
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.ExpirationDate" @input="menu4 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Api Role Id -->
                      <v-select
                        v-model="editedItem.ApiRole_id"
                        :items="roles"
                        :rules="idRolRules"
                        label="Rol ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"> <!-- Last User Id -->
                      <v-text-field :disabled="true"  v-model="editedItem.LastUser_id"
                        label="Usuario Creación"  :counter="50" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12"> <!-- Dias de la semana -->
                      <span>{{ 'Días de la semana: '}}</span>
                      <v-row justify="space-around">
                      
                      <v-checkbox v-model="selectedDays" label="Lunes" value="1"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Martes" value="2"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Miercoles" value="3"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Jueves" value="4"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Viernes" value="5"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Sabado" value="6"></v-checkbox>
                      <v-checkbox v-model="selectedDays" label="Domingo" value="7"></v-checkbox>
                    </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions> <!-- Botones -->
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
    <v-tooltip bottom>
     <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="item.ExpirationDate >= fecha_hoy"
        small
        class="mr-2"
        v-bind="attrs"
        v-on="on"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      </template>
      <span>Editar</span>
      </v-tooltip>
      <v-tooltip bottom>
     <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="item.ExpirationDate >= fecha_hoy"
        small
        @click="closedItem(item)"
        v-bind="attrs"
        v-on="on"
      >
        mdi-lock
      </v-icon>
      </template>
      <span>Cerrar Vigencia</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
var fecha_hoy= new Date().toISOString().substr(0, 10)
var fecha_pasada = new Date(new Date().getTime() - (24 * 60 * 60 * 1000)).toISOString().substr(0, 10)
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    fecha_hoy,
    fecha_pasada,
    headers: [
      { text: 'BlackOut ID', value: 'BlackOut_id' },
      { text: 'Descripcion BlackOut', value: 'BlackOut_Desc' },
      { text: 'Hora Inicio', value: 'BlackOutStart_tm' },
      { text: 'Hora Fin', value: 'BlackOutEnd_tm' },
      { text: 'Fecha efectivo', value: 'EffectiveDate' },
      { text: 'Fecha expiración', value: 'ExpirationDate' },
      { text: 'Dias de Blackout', value: 'days'},
      { text: 'Rol Id', value: 'ApiRole_id' },
      { text: 'Usuario', value: 'LastUser_id' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    blackout: [],
    blackoutDays: [],
    blackoutWDays: [],
    roles: [],
    editedIndex: -1,
    editedItem: {
      BlackOut_id:'',
      BlackOut_Desc:'',
      BlackOutStart_tm: new Date().toLocaleTimeString(),
      BlackOutEnd_tm:'23:59:59',
      EffectiveDate: new Date().toISOString().substr(0, 10),
      ExpirationDate: '9999-12-31',
      ApiRole_id: 'default',
      LastUser_id: sessionStorage.getItem('ApiUser_id'),
    },
    defaultItem: {
      BlackOut_id:'',
      BlackOut_Desc:'',
      BlackOutStart_tm: new Date().toLocaleTimeString(),
      BlackOutEnd_tm:'23:59:59',
      EffectiveDate: new Date().toISOString().substr(0, 10),
      ExpirationDate: '9999-12-31',
      ApiRole_id: 'default',
      LastUser_id: sessionStorage.getItem('ApiUser_id')
    },
    selectedDays: [],
    originalDays: [],
    overlay: false,
    overlayStart: false,
    titleCard: "Cargando datos",
    idRules: [
      v => !!v || 'BlackOut ID es requerido',
      v => (v && v.length <= 5) || 'BlackOut ID debe tener menos de 5 caracteres'
    ],
    DescRules: [
      v => !!v || 'Descripción es requerida',
      v => (v && v.length <= 50) || 'La Descripción debe tener menos de 50 caracteres'
    ],
    InicioRules: [
      v => !!v || 'Inicio es requerido'
    ],
    FinRules: [
      v => !!v || 'Fin es requerido'
    ],
    idRolRules: [
      v => !!v || 'Rol ID es requerido'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo BlackOut' : 'Editar BlackOut'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.overlayStart = true;
      axios.post(this.api_tool_url + '/get_blackout', {}, this.config)
        .then(response => {
          this.blackout = response.data.ResultRows
        })
        .catch(error => {
          this.blackout = []
          alert(error.response.data.message)
        }).then(resp => {
          axios.post(this.api_tool_url + '/get_blackout_days', {}, this.config)
          .then(response => {
            //Cambiar luego por un for sin considerar vacíos.
            this.generateBlackoutWithDays(response.data.ResultRows)
            this.overlayStart = false;
          })
          .catch(error => {
            this.blackout = []
            alert(error)
            this.overlayStart = false;
          })

        })

     
      axios.post(this.api_tool_url + '/get_roles', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.roles.push(data.ApiRole_id)
          })
        })
        .catch(error => {
          this.roles = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.blackout.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
      this.selectedDays=[]
    },

    editItem (item) {
      this.editedIndex = this.blackout.indexOf(item)
      this.editedItem = Object.assign({}, item)
      
      this.selectedDays=[]
      item.days.split(',').map((day,index) => {
        if(day == 'S'){
          this.selectedDays.push(String(index + 1))
        }
      })
      this.dialog = true
    },

    closedItem (item) {
      const index = this.blackout.indexOf(item)
      confirm('Esta seguro que quiere cerrar esta vigencia?') && this.closedBlackOut(index)
    },

    closedBlackOut (index) {
      this.overlayStart = true;
      this.titleCard = "Cerrando vigencia..."
      let blackoutDays = this.blackoutWDays.filter((day) => day.BlackOut_id == 5 )[0]
      let itemObj = {
        BlackOut_id: blackoutDays.BlackOut_id,
        WeekDay_id: '', 
        Enabled_Ind: '',
        EffectiveDate: blackoutDays.EffectiveDate,
        ExpirationDate:  this.fecha_pasada
      }

      let enabled_Inds = blackoutDays.days.split(',')

      
      let tmpblackout = this.blackout[index]
      tmpblackout.ExpirationDate = this.fecha_pasada

      let editObj = {
        ApiRole_id: this.blackout[index].ApiRole_id,
        BlackOutEnd_tm: this.blackout[index].BlackOutEnd_tm,
        BlackOutStart_tm: this.blackout[index].BlackOutStart_tm,
        BlackOut_Desc: this.blackout[index].BlackOut_Desc,
        BlackOut_id: this.blackout[index].BlackOut_id,
        EffectiveDate: this.blackout[index].EffectiveDate,
        ExpirationDate: this.fecha_pasada,
        LastUser_id:this.blackout[index].LastUser_id
      }

      axios.post(this.api_tool_url + '/upd_blackout', editObj, this.config)
          .then(response => {
            this.blackout = []
            this.blackout = response.data.ResultRows

          })
          .catch(error => {
            this.blackout = []
            alert(error.response.data.message)
           })
           .then(resp => {
            itemObj.WeekDay_id    = 1
            itemObj.Enabled_Ind   = enabled_Inds[0]

            axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
            .then(response => {
              // console.log(response)
              this.titleCard = "Cerrando vigencia día 1..."
              itemObj.WeekDay_id    = 2
              itemObj.Enabled_Ind   = enabled_Inds[1]
              axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
              .then(response => {
                // console.log(response)
                this.titleCard = "Cerrando vigencia día 2..."
                itemObj.WeekDay_id    = 3
                itemObj.Enabled_Ind   = enabled_Inds[2]
                axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                .then(response => {
                  // console.log(response)
                  this.titleCard = "Cerrando vigencia día 3..."
                  itemObj.WeekDay_id    = 4
                  itemObj.Enabled_Ind   = enabled_Inds[3]
                  axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                  .then(response => {
                    // console.log(response)
                    this.titleCard = "Cerrando vigencia día 4..."
                    itemObj.WeekDay_id    = 5
                    itemObj.Enabled_Ind   = enabled_Inds[4]
                    axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                    .then(response => {
                      // console.log(response)
                      this.titleCard = "Cerrando vigencia día 5..."
                      itemObj.WeekDay_id    = 6
                      itemObj.Enabled_Ind   = enabled_Inds[5]
                      axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                      .then(response => {
                        // console.log(response)
                        this.titleCard = "Cerrando vigencia día 6..."
                        itemObj.WeekDay_id    = 7
                        itemObj.Enabled_Ind   = enabled_Inds[6]
                        axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                        .then(response => {
                          // console.log(response)
                          this.titleCard = "Cerrando vigencia día 7..."
                          this.generateBlackoutWithDays(response.data.ResultRows)
                          this.overlayStart = false;
                          this.close()
                        })
                      })
                    })
                  })
                })
              })
            })
          })
          .catch(error => {
            alert(error.response.data.message)
            alert(error)
            this.overlayStart = false;
          })
    },

    close () {
      this.dialog = false
      this.dialog_pass = false
      this.dialog_new = false
      this.selectedDays = []
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)

      
    },

    save () {
      this.overlay = true;
      
      if (this.editedIndex > -1) {
        this.titleCard = "Editando registro..."
        let itemObj = {
          BlackOut_id:this.editedItem.BlackOut_id,
          WeekDay_id: '', 
          Enabled_Ind: '',
          EffectiveDate: this.editedItem.BlackOut_id.EffectiveDate,
          ExpirationDate: this.editedItem.BlackOut_id.ExpirationDate
        }

        let enabled_Inds = []

        for(let i = 1; i <= 7 ; i++){
          if(this.selectedDays.find(index => index == i)){
            enabled_Inds.push('S')
          }else{
            enabled_Inds.push('N')
          }
        }

        let editObj = {
          ApiRole_id: this.editedItem.ApiRole_id,
          BlackOutEnd_tm: this.editedItem.BlackOutEnd_tm,
          BlackOutStart_tm: this.editedItem.BlackOutStart_tm,
          BlackOut_Desc: this.editedItem.BlackOut_Desc,
          BlackOut_id: this.editedItem.BlackOut_id,
          EffectiveDate: this.editedItem.EffectiveDate,
          ExpirationDate: this.editedItem.ExpirationDate,
          LastUser_id: this.editedItem.LastUser_id
        }

        axios.post(this.api_tool_url + '/upd_blackout', editObj, this.config)
          .then(response => {
            this.blackout = []
            this.blackout = response.data.ResultRows
          })
          .catch(error => {
            this.blackout = []
            alert(error.response.data.message)
          }).then(resp => {
            itemObj.WeekDay_id = 1
            itemObj.Enabled_Ind = enabled_Inds[0]
            axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
            .then(response => {
              // console.log(response)
              this.titleCard = "Editando día 1..."
              itemObj.WeekDay_id = 2
              itemObj.Enabled_Ind = enabled_Inds[1]
              axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
              .then(response => {
                // console.log(response)
                this.titleCard = "Editando día 2..."
                itemObj.WeekDay_id = 3
                itemObj.Enabled_Ind = enabled_Inds[2]
                axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                .then(response => {
                  // console.log(response)
                  this.titleCard = "Editando día 3..."
                  itemObj.WeekDay_id = 4
                  itemObj.Enabled_Ind = enabled_Inds[3]
                  axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                  .then(response => {
                    // console.log(response)
                    this.titleCard = "Editando día 4..."
                    itemObj.WeekDay_id = 5
                    itemObj.Enabled_Ind = enabled_Inds[4]
                    axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                    .then(response => {
                      // console.log(response)
                      this.titleCard = "Editando día 5..."
                      itemObj.WeekDay_id = 6
                      itemObj.Enabled_Ind = enabled_Inds[5]
                      axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                      .then(response => {
                        // console.log(response)
                        this.titleCard = "Editando día 6..."
                        itemObj.WeekDay_id = 7
                        itemObj.Enabled_Ind = enabled_Inds[6]
                        axios.post(this.api_tool_url + '/upd_blackout_days', itemObj, this.config)
                        .then(response => {
                          // console.log(response)
                          this.titleCard = "Editando día 7..."
                          this.generateBlackoutWithDays(response.data.ResultRows)
                          this.overlay = false;
                          this.close()
                        })
                      })
                    })
                  })
                })
              })
            })
          })
          .catch(error => {
            alert(error.response.data.message)
            alert(error)
            this.overlay = false;
          })
        // Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        this.titleCard = "Insertando registros..."
        let itemObj = {
            BlackOut_id:'',
            WeekDay_id: '', 
            Enabled_Ind: '',
            EffectiveDate: new Date().toISOString().substr(0, 10),
            ExpirationDate: '9999-12-31'
          }

          let enabled_Inds = []

          for(let i = 1; i <= 7 ; i++){
            if(this.selectedDays.find(index => index == i)){
              enabled_Inds.push('S')
            }else{
              enabled_Inds.push('N')
            }
          }
        axios.post(this.api_tool_url + '/ins_blackout', this.editedItem, this.config)
          .then(response => {
            // console.log(response)
            this.blackout = []
            this.blackout = response.data.ResultRows
          })
          .catch(error => {
            this.blackout = []
            alert(error.response.data.message)
          }).then(resp => {
            itemObj.WeekDay_id = 1
            itemObj.Enabled_Ind = enabled_Inds[0]
            axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
            .then(response => {
              // console.log(response)
              this.titleCard = "Insertando día 1..."
              itemObj.WeekDay_id = 2
              itemObj.Enabled_Ind = enabled_Inds[1]
              axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
              .then(response => {
                // console.log(response)
                this.titleCard = "Insertando día 2..."
                itemObj.WeekDay_id = 3
                itemObj.Enabled_Ind = enabled_Inds[2]
                axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
                .then(response => {
                  // console.log(response)
                  this.titleCard = "Insertando día 3..."
                  itemObj.WeekDay_id = 4
                  itemObj.Enabled_Ind = enabled_Inds[3]
                  axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
                  .then(response => {
                    // console.log(response)
                    this.titleCard = "Insertando día 4..."
                    itemObj.WeekDay_id = 5
                    itemObj.Enabled_Ind = enabled_Inds[4]
                    axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
                    .then(response => {
                      // console.log(response)
                      this.titleCard = "Insertando día 5..."
                      itemObj.WeekDay_id = 6
                      itemObj.Enabled_Ind = enabled_Inds[5]
                      axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
                      .then(response => {
                        // console.log(response)
                        this.titleCard = "Insertando día 6..."
                        itemObj.WeekDay_id = 7
                        itemObj.Enabled_Ind = enabled_Inds[6]
                        axios.post(this.api_tool_url + '/ins_blackout_days', itemObj, this.config)
                        .then(response => {
                          // console.log(response)
                          this.titleCard = "Insertando día 7..."
                          this.generateBlackoutWithDays(response.data.ResultRows)
                          this.overlay = false;
                          this.close()
                        })
                      })
                    })
                  })
                })
              })
            })
          })
          .catch(error => {
            alert(error.response.data.message)
            alert(error)
            this.overlay = false;
          })
        }
    },

    generateBlackoutWithDays(responseArr){
      this.blackoutWDays = []
      this.blackoutDays = responseArr
      let bObj = {}
      this.blackout.map((bo)=>{
        // console.log(bo.BlackOut_id)
        bObj = bo
        let bodArr = this.blackoutDays.filter((bod)=> bod.BlackOut_id == bo.BlackOut_id)
        let daysArr = ''
        if(bodArr.length > 0){
          for(let i=1; i<= 7; i++){
            let bAux = bodArr.find((b) => b.WeekDay_id == i)
            daysArr += bAux["Enabled_Ind"].trim()
            if(i!=7){
              daysArr +=','
            }
          }
        }else{
          daysArr='N,N,N,N,N,N,N'
        }
        bObj["days"] = daysArr
        this.blackoutWDays.push(bObj)
      })
    }

  }
}
</script>


// WEBPACK FOOTER //
// src/components/BlackOutGrid.vue